import { FC } from "react";
import { TextSkeleton } from "../Loading";

export const LoadingEditor: FC = () => {
  return <div className={"bg-white border-2 border-slate-100 rounded-lg"}>
    <table className={"w-full"}>
      <tbody>
        <LoadingRecord />
        <LoadingRecord />
        <LoadingRecord />
        <LoadingRecord />
        <LoadingRecord />
      </tbody>
    </table>
  </div>
}

const LoadingRecord = () => {
  return <tr>
    <td className={"w-32 h-10 px-2"}>
      <TextSkeleton size={"sm"} />
    </td>
    <td className={"h-10 px-2"}>
      <TextSkeleton size={"md"} />
    </td>
    <td className={"w-3/5 h-10 px-2"}>
      <TextSkeleton size={"lg"} />
    </td>
  </tr>
}
